<template>
  <v-container class="pt-0">
    <v-layout xs12>
      <h1>Crew Members</h1>
      <v-progress-circular class="ml-3" v-if="loadingCrew" indeterminate />
      <v-spacer/>

      <div v-if="detailed">
        <v-container class="pa-0">
          <v-layout align-center>
            <v-checkbox v-model="viewInactive" label="View Inactive"/>

            <add-crew-member />
          </v-layout>
        </v-container>
      </div>

      <v-btn flat color="green" router to="crew" v-else-if="isLoggedIn">
        <span>Manage Crew</span>
        <v-icon right>people</v-icon>
      </v-btn>
    </v-layout>

    <v-layout xs12>
      <v-list two-line>
        <template v-for="member in this.$store.state.crewMembers">
          <v-list-tile :key="member.name" avatar @click="" class="crewMember"
                       v-if="viewInactive && member.inactive || member.inactive === false">
            <v-list-tile-avatar>
              <v-avatar color="orange darken-3" size="40">
                <span>{{ getInitials(member.name) }}</span>
              </v-avatar>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>
                {{ member.name }}
                <span class="grey--text font-italic" v-if="viewInactive && member.inactive">(Inactive)</span>
                <span class="gamesWorked">{{ member.games }} games</span>
              </v-list-tile-title>
              <v-list-tile-sub-title v-if="isLoggedIn">
                <a class="crewEmail" :href="getMailtoLink(member.email)">{{ member.email }}</a>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="detailed">
              <v-btn v-if="member.inactive === false" flat color="error" class="px-2"
                     @click="toggleMemberInactive(member)">
                <span>Set Inactive</span>
                <v-icon right>archive</v-icon>
              </v-btn>

              <v-btn v-else flat color="info" class="px-2"
                     @click="toggleMemberInactive(member)">
                <span>Set Active</span>
                <v-icon right>unarchive</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action class="mx-2" v-if="isLoggedIn">
              <router-link :to="{path: `crew/m/${member.id}`}">
                <v-btn flat class="px-2">
                  <span>details</span>
                  <v-icon right>arrow_forward</v-icon>
                </v-btn>
              </router-link>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-layout>
  </v-container>
</template>

<script>
import AddCrewMember from './AddCrewMember.vue';
import {db} from '../fbConfig';

export default {
  name: 'CrewList',
  components: {AddCrewMember},
  props: [
    'detailed'
  ],
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  data() {
    return {
      viewInactive: false,
      loadingCrew: false
    };
  },
  methods: {
    getInitials(name) {
      const names = name.split(' ');
      return (names[0].substring(0, 1) + names[names.length - 1].substring(0, 1)).toUpperCase();
    },

    getMailtoLink(email) {
      return `mailto:${email}`;
    },

    async toggleMemberInactive(member) {
      if (member.inactive === false) {
        const result = await this.$confirm('Are you sure you want to set this crew member as inactive?<br/><br/>'
          + 'They will no longer show up when adding a Crew Assignment for an event.', {
          title: 'Are you sure?'
        });
        if (result === false) {
          return;
        }
      }

      member.inactive = !member.inactive;
      const docRef = db.collection('CrewMembers').doc(member.id);
      docRef.get().then(async () => {
        const update = {inactive: member.inactive};
        await docRef.update(update);
      });
    }
  },
  created() {
    this.loadingCrew = true;

    db.collection('CrewMembers').onSnapshot(res => {
      for (const change of res.docChanges()) {
        // TODO: Handle removed/deleted/changed/whatever
        if (change.type === 'added') {
          this.$store.commit('addCrewMember', {
            id: change.doc.id,
            ...change.doc.data()
          });
        }
      }

      this.loadingCrew = false;
    });
  }
};
</script>

<style scoped>
  .v-list {
    width: 100%;
  }

  .gamesWorked {
    border: 1px solid #1E88E5;
    border-radius: 10px;
    padding: 1px 10px;
    margin-left: 10px;
  }

  .crewEmail {
    color: #BDBDBD;
    text-decoration: none;
  }

  .crewMember > a {
    /* FIXME: */
    cursor: default !important;
  }
</style>
